import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Outlet, useLocation, Navigate } from "react-router-dom";

/// Css
import "./index.css";
/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
import Home from "./components/Dashboard/Home";
import Login from "./pages/Login";
// Notify Admin List
import NotifyAdminList from "./pages/NotifyAdmin/NotifyAdminList";
/// Table
import BuilderTable from "./pages/Builder/BuilderList";
import SubdivisionList from "./pages/Subdivision/SubdivisionList";
import SubdivisionUpdate from "./pages/Subdivision/SubdivisionUpdate";
import ProductListList from "./pages/Product/ProductList";
import UserList from "./pages/User/UserList";
// import AccountAdminUser from "./pages/User/AccountAdminUser";

import UserUpdate from "./pages/User/UserUpdate";
import ProductUpdate from "./pages/Product/ProductUpdate";
import PermitList from "./pages/Permit/PermitList";
import PermitUpdate from "./pages/Permit/PermitUpdate";
import LandsaleList from "./pages/Landsale/LandsaleList";
import LandsaleUpdate from "./pages/Landsale/LandsaleUpdate";
import TrafficsaleList from "./pages/Trafficsale/TrafficsaleList";
import TrafficsaleUpdate from "./pages/Trafficsale/TranfficsaleUpdate";
import ClosingList from "./pages/Closing/ClosingList";
import ClosingUpdate from "./pages/Closing/ClosingUpdate";
// import Statistics from "./pages/Statistics/Statistics";
import WeeklyData from "./pages/WeeklyData/WeeklyData";
import WeeklyDataIndex from "./pages/WeeklyData/WeeklyDataIndex";
import File from "./pages/File/File";
import Report from "./pages/Report/Report";
import ReportList from "./pages/Report/ReportList";
import Error404 from "./pages/Error404";
// import Error403 from "./pages/Error403";
import PriceList from "./pages/Price/PriceList";
import PriceUpdate from "./pages/Price/PriceUpdate";

import BuilderUpdate from "./pages/Builder/BuilderUpdate";
import GoogleMapLocator from "./pages/Subdivision/GoogleMapLocator";
import CCAPNList from "./pages/CCAPN/CCAPNList";
import FilterBuilder from "./pages/Builder/FilterBuilder";
import FilterSubdivision from "./pages/Subdivision/FilterSubdivision";
import FilterLandSales from "./pages/Landsale/FilterLandSales";
import FilterBasePrice from "./pages/Price/FilterBasePrice";
import FilterProducts from "./pages/Product/FilterProducts";
import FilterPermits from "./pages/Permit/FilterPermits";
import FilterWeeklyTrafficAndSales from "./pages/Trafficsale/FilterWeeklyTrafficAndSales";
import FilterClosings from "./pages/Closing/FilterClosings";
import ArchiveData from "./pages/ArchiveData/ArchiveData";
import SubscriberList from "./pages/Subscriber/SubscriberList";
import SubscriptionPlan from "./pages/SubscriptionPlan/SubscriptionPlan";
import ThankYouPage from "./pages/ThankYouPage";
import SubscriptionList from "./pages/SubscriptionPlan/SubscriptionList";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import UserAnalyticsList from "./pages/UserAnalytics/UserAnalyticsList";
import ArchiveDataUpdate from "./pages/ArchiveData/ArchiveDataUpdate";
import ScrapPriceList from "./pages/ScrapedPrices/ScrapPriceList";
import Termsofservice from "./pages/Termsofservice";
import Registration from "./pages/Registration";
import CouponList from "./pages/Coupon/CouponList";
import PaymentList from "./pages/Payment/PaymentList";
import SettingsOffCanvas from "./pages/Settings/SettingsOffCanvas";
import { getStoredIsSubscribed } from "../utils/subscriptionAccess";

const allroutes = [
  // Dashboard
  { url: "", 
    component: <Login /> 
  },
  { url: "/registration", 
    component: <Registration /> 
  },
  { url: "dashboard", component: <Home />, 
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"] 
  },
  { url: "/builderList", 
    component: <BuilderTable />, 
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"] 
  },
  {
    url: "/subdivisionlist",
    component: <SubdivisionList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "subdivisionUpdate/:id",
    component: <SubdivisionUpdate />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "builderUpdate/:id",
    component: <BuilderUpdate />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/priceList",
    component: <PriceList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/priceupdate/:id",
    component: <PriceUpdate />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/productlist",
    component: <ProductListList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/productupdate/:id",
    component: <ProductUpdate />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  { url: "/userlist", 
    component: <UserList />, 
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff"]   
  },
  // { url: "/userlist/accountAdmin", 
  //   component: <AccountAdminUser />,       
  //   allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff"] 
  // },
  { url: "/useranalytics/:id", 
    component: <UserAnalyticsList />, 
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff"] 
  },
  {
    url: "/userupdate/:id",
    component: <UserUpdate />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff"],
  },
  { url: "/permitlist", 
    component: <PermitList />, 
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"] 
  },
  {
    url: "/permitupdate/:id",
    component: <PermitUpdate />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/landsalelist",
    component: <LandsaleList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/landsaleupdate/:id",
    component: <LandsaleUpdate />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/trafficsalelist",
    component: <TrafficsaleList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/trafficsaleupdate/:id",
    component: <TrafficsaleUpdate />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/closingsalelist",
    component: <ClosingList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/closingsaleupdate/:id",
    component: <ClosingUpdate />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  // { url: "/statistics", component: <Statistics />, allowedRoles: ["Admin"] },
  {
    url: "/weekly-data",
    component: <WeeklyData />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin & Data Uploader", "Staff", "Tester Data Uploader" ],
  },
  {
    url: "/weekly-data-index",
    component: <WeeklyDataIndex />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin & Data Uploader", "Staff", "Tester Data Uploader"],
  },
  { url: "/files", 
    component: <File />, 
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff"] 
  },
  { url: "/report", 
    component: <Report />, 
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff"] 
  },
  {
    url: "/report-list",
    component: <ReportList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff"],
  },
  {
    url: "/google-map-locator",
    component: <GoogleMapLocator />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/ccapn",
    component: <CCAPNList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader"],
  },
  {
    url: "/downloading-archive-data",
    component: <ArchiveData />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff"],
  },
  {
    url: "/archivedata-update/:id",
    component: <ArchiveDataUpdate />,
    allowedRoles: ["Admin", "Staff"],
  },
  {
    url: "/subscriberlist",
    component: <SubscriberList />,
    allowedRoles: ["Admin", "Tester", "Tester Account Admin", "Tester Data Uploader"],
  },
  {
    url: "/subscriptionplan",
    component: <SubscriptionPlan />,
    allowedRoles: ["Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader"],
  },
  {
    url: "/subscriptionlist",
    component: <SubscriptionList />,
    allowedRoles: ["Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader"],
  },
  {
    url: "/filterbuilder",
    component: <FilterBuilder />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/filtersubdivision",
    component: <FilterSubdivision />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/filterlandsales",
    component: <FilterLandSales />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/filterbaseprice",
    component: <FilterBasePrice />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/scrapepricelist",
    component: <ScrapPriceList />,
    allowedRoles: ["Admin", "User","Standard User","Account Admin", "Account Admin & Data Uploader"],
  },
  {
    url: "/filterproducts",
    component: <FilterProducts />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/filterpermits",
    component: <FilterPermits />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/filterweeklytrafficandsales",
    component: <FilterWeeklyTrafficAndSales />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/filterclosings",
    component: <FilterClosings />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/notifyuserlist",
    component: <NotifyAdminList />,
    allowedRoles: ["Admin", "Staff"],
  },
  {
    url: "/couponlist",
    component: <CouponList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Account Admin & Data Uploader", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin"],
  },
  {
    url: "/paymentlist",
    component: <PaymentList />,
    allowedRoles: ["Admin", "Standard User", "Data Uploader", "Account Admin", "Staff", "Tester", "Tester Account Admin", "Tester Data Uploader", "Tester Data Uploader & Tester Account Admin", "Account Admin & Data Uploader"],
  },
  {
    url: "/settings",
    component: <SettingsOffCanvas />,
    allowedRoles: ["Admin"],
  },
  // {
  //   url: "/thank-you",
  //   component: <ThankYouPage />,
  //   allowedRoles: ["User","Standard User"],
  // },
];

const Markup = () => {
  const userData = JSON.parse(localStorage.getItem('user'));
  let currentRole = '';
  let isSubscribed = '1';

  if(userData) {
    currentRole = userData.role;
    isSubscribed = userData.is_subscribed;
  }

  const allowedRoles = currentRole?.includes("&") ? currentRole?.split("&").map(role => role.trim()) : [currentRole?.trim()];

  const filteredRoutes = allroutes.filter((route) => {
    return (
      route.allowedRoles &&
      route.allowedRoles.some((role) => allowedRoles.includes(role))
    );
  });

  // const finalRoutes = filteredRoutes.filter((route) => {
  //   if (isSubscribed == "0" && !allowedRoles?.includes("Admin") && !allowedRoles?.includes("Staff") && !allowedRoles?.includes("Tester") && !allowedRoles?.includes("Tester Data Uploader")) {
  //     return route.url === "/subscriptionplan" || route.url === "/subscriptionlist" || route.url === "/paymentlist";
  //   }
  //   return true;
  // });

  // console.log(finalRoutes)
  
  function NotFound() {
    return <Error404 />;
  }

  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/terms" element={<Termsofservice />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route element={<MainLayout />}>
          {filteredRoutes?.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </Fragment>
  );
};

function MainLayout() {
  const sideMenu = useSelector((state) => state.sideMenu);
  const location = useLocation();

  const userData = JSON.parse(localStorage.getItem('user'));
  const isSubscribed = getStoredIsSubscribed(userData);
  const currentRole = userData?.role || "";
  const allowedRoles = currentRole?.includes("&") ? currentRole?.split("&").map(role => role.trim()) : [currentRole?.trim()];

  const bypassSubscription = allowedRoles?.includes("Admin") || allowedRoles?.includes("Staff") || allowedRoles?.includes("Tester") || allowedRoles?.includes("Tester Account Admin") || allowedRoles?.includes("Tester Data Uploader") || allowedRoles?.includes("Tester Data Uploader & Tester Account Admin");
  const allowedUrlsForUnsubscribed = ["/subscriptionplan", "/subscriptionlist", "/paymentlist"];

  if (String(isSubscribed) === "0" && !bypassSubscription) {
    if (!allowedUrlsForUnsubscribed.includes(location.pathname)) {
      return <Navigate to="/subscriptionplan" replace />;
    }
  }

  return (
    <div id="main-wrapper" className={`show ${sideMenu ? "menu-toggle" : ""}`}>
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default Markup;
